import { API, Auth } from 'aws-amplify'

const authHeader = async () => {
  const token = (await Auth.currentAuthenticatedUser()).signInUserSession.idToken
    .jwtToken
  return { Authorization: `Bearer ${token}` }
}

/** GET /billing-stats con los parámetros dados (los vacíos se omiten). */
export const getBilling = async (params) => {
  const qs = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
  ).toString()
  const headers = await authHeader()
  return API.get('rcs-api', `/billing-stats${qs ? `?${qs}` : ''}`, { headers })
}

export const getRates = async () => {
  const headers = await authHeader()
  return API.get('rcs-api', '/orange-rates', { headers })
}

export const saveRates = async (body) => {
  const headers = await authHeader()
  return API.post('rcs-api', '/orange-rates', { headers, body })
}

/** Guarda las cifras de la factura de Orange de un mes ({ month, conversaciones, simple, basico, total }). */
export const saveInvoice = async (invoice) => {
  const headers = await authHeader()
  return API.post('rcs-api', '/orange-rates', { headers, body: { invoice } })
}
